import MultiSelectFilter from '../MultiSelectFilter'
import { BUG_CATEGORIES, bugCategoryLabel } from '../../../netlify/functions/lib/polish-pass-types'

// Derived from BUG_CATEGORIES so every kind a bug can carry is filterable.
export const KIND_OPTIONS = BUG_CATEGORIES.map(value => ({ value, label: bugCategoryLabel(value) }))

/** The bug-list API's `kind` param: a comma-separated list, or `all` when nothing is selected. */
export function bugKindParam(kinds: string[]): string {
  return kinds.length > 0 ? kinds.join(',') : 'all'
}

interface BugKindFilterProps {
  /** Selected kinds; empty means every kind. */
  value: string[]
  onChange: (value: string[]) => void
}

export default function BugKindFilter({ value, onChange }: BugKindFilterProps) {
  return (
    <MultiSelectFilter
      value={value}
      onChange={onChange}
      options={KIND_OPTIONS}
      label="Kind"
      analyticsPrefix="bug-kind-filter"
      testId="kind-filter"
    />
  )
}
